export default __webpack_public_path__ + "1dceffd3a4a91e36187da32d4a443a1b.ttf";